import React, { Component } from 'react'
import './Signin.scss';
import Logo from './Logo_svg.svg';
import {Link} from 'react-router-dom';

import OktaAuth from '@okta/okta-auth-js';
import { withOktaAuth } from '@okta/okta-react';

import oktaConfig from '../../oidc/test.oidc';

export default withOktaAuth(class Signin extends Component {
    constructor(props){
        super(props);
        this.state = {sessionToken: null};
        this.oktaAuth = new OktaAuth({ issuer: oktaConfig.oidc.issuer });
    }

    submit(e) {
        e.preventDefault();
        const username = e.target.username.value,
            password = e.target.password.value;
        this.oktaAuth.signIn({
            username: username,
            password: password
        }).then(res => {
            const sessionToken = res.sessionToken;
            this.setState(
                { sessionToken: sessionToken },
                () => this.props.authService.redirect({sessionToken})
            );
        }).catch(err => console.log('Sign on error', err));
    }
    render() {
        console.log(this.props.authState);
        return (
            <div className="login-container-bg">
                <div className="overlay"></div>
                <div className="login-form">
                    <div className="logo-container">
                        <Link to='/'><img src={Logo} alt="Logo"/></Link>
                        <p className="logo-title">GameMeet</p>
                    </div>
                    <form className="login-form-container" onSubmit={(e)=>this.submit(e)}>
                        <p className="login-form-title">
                            Sign In
                        </p>
                        <div className="information-button">
                            <p>Username / Email</p>
                            <input className="signin-button" name="username" />
                            {/* <Input inputtype="input" type="text" name="name" placeholder="Your Name"/> */}
                        </div>
                        <div className="information-button">
                            <p>Password</p>
                            <input className="signin-button" name="password" />
                        </div>
                        <div className="LogIn">
                           <button className="login-button" type="submit">Log in</button>
                        </div>
                        <div className="otherwaylogin">
                            <p>Other ways to Log in</p>
                            <button className="FBlogin-button" />
                            <button className="Discordlogin-button" />
                        </div>
                        <div className="signinhyperlink">
                            <p><Link to="./forgot-password">Forgot password?</Link></p>
                            <p><Link to="./register">No an account? Join in us</Link></p>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
});
